import { SelectOption } from '@pf/shared-common';

/**
 * Converts an enum object to an array of SelectOption objects.
 * @param e Enum object to be converted.
 * @returns Array of SelectOption objects.
 */
export function enumToSelectOptions<
    TEnum extends Record<string, string | number>,
>(e: TEnum): SelectOption[] {
    return Object.keys(e).map(key => ({
        label: e[key as keyof TEnum],
        value: key,
    }));
}

/**
 * Finds the key of an enum given its label.
 * @param e Enum object.
 * @param label Label to search for.
 * @returns The key corresponding to the given label or undefined if not found.
 */
export function enumLabelToKey<TEnum extends Record<string, string>>(
    e: TEnum,
    label: string
): string | undefined {
    return Object.keys(e).find(key => e[key as keyof TEnum] === label);
}
